import { DocumentIssuanceConstant } from "presentation/constant/DocumentIssuance/DocumentIssuanceConstant";
import { useDocumentIssuanceVM } from "presentation/hook/DocumentIssuance/useDocumentIssuanceVM";
import { useMessageBarVM } from "presentation/hook/useMessageBar";
import { useANAInfoTracked } from "presentation/store/ANAInfo";
import { useDocumentIssuanceTracked } from "presentation/store/DocumentIssuance/DocumentIssuanceProvider";
import { memo, useCallback, useState } from "react";
import { HPHBreadcrumb, IconButton, Loader } from "veronica-ui-component/dist/component/core";
import { Breadcrumb, Sidebarheader, StyledAction } from "veronica-ui-component/dist/component/core/styled/uiFramework.styled";

const DocumentIssuanceEditPanelTitleBar: React.FC = () => {
    const [documentIssuanceState] = useDocumentIssuanceTracked();
    const documentIssuanceVM = useDocumentIssuanceVM();
    const messageBarVM = useMessageBarVM();
    const { currentSelectedRow, masterState, dynamicOptions } = documentIssuanceState;
    const { editingEntity, isAdd, isEditable, isRead, companyCode, customerCode } = masterState;

    const [anainfoState] = useANAInfoTracked();
    const { allowCreate, allowUpdate } = anainfoState;
    const [isLoading, setIsLoading] = useState(false);
    const currentEntity = isRead ? currentSelectedRow : editingEntity;

    const isDisable = () => {
        /*if (isCompAdd || (!isCompAdd && isCompEdit)) return true;*/

        return false;
    }

    const handleReset = useCallback(async () => {
        documentIssuanceVM.onResetClick();
    }, [documentIssuanceVM]);

    const handleEdit = useCallback(() => {
        documentIssuanceVM.onEdit(currentEntity);
    }, [currentEntity, documentIssuanceVM])

    const handleSave = useCallback(async () => {
        const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
        let valid = false;
        if (currentEntity.ediEmailAddress) {
            const emails = currentEntity.ediEmailAddress.split(";");
            emails?.forEach(email => {
                if (!emailRegex.test(email)) {
                    messageBarVM.showError("The Edi Email Address '" + email + "' is not valid.");
                    valid = true;
                    return;
                }
            });
        }
        if (currentEntity.copyTo) {
            const emails = currentEntity.copyTo.split(";");
            emails?.forEach(email => {
                if (!emailRegex.test(email)) {
                    messageBarVM.showError("The Cc '" + email + "' is not valid.");
                    valid = true;
                    return;
                }
            });
        }
        if (currentEntity.emailAddress) {
            const emails = currentEntity.emailAddress.split(";");
            emails?.forEach(email => {
                if (!emailRegex.test(email)) {
                    messageBarVM.showError("The Email Address '" + email + "' is not valid.");
                    valid = true;
                    return;
                }
            });
        }
        // if (currentEntity.noOfCopy && currentEntity.noOfCopy > 99) {
        //     messageBarVM.showError("The No. Of Copies should be less than or equal to 99.");
        //     valid = true;
        //     return;
        // }
        // if (currentEntity.noOfOriginal && currentEntity.noOfOriginal > 99) {
        //     messageBarVM.showError("The No. Of Original should be less than or equal to 99.");
        //     valid = true;
        //     return;
        // }
        // if (currentEntity.noOfSupportingDoc && currentEntity.noOfSupportingDoc > 99) {
        //     messageBarVM.showError("The No. Of Supporting Doc. should be less than or equal to 99.");
        //     valid = true;
        //     return;
        // }
        if (valid) {
            return;
        }
        setIsLoading(true);
        try {
            documentIssuanceVM.onSaveClicked();
            let entity = {
                ...currentEntity,
                billToCompanyId: companyCode ? Number(dynamicOptions.billToCompanyDropdownOptions?.find(item => item.value === companyCode)?.tagLabel) : null,
                customerId: customerCode ? Number(dynamicOptions.customerCodeDropdownOptions?.find(item => item.value === customerCode)?.tagLabel) : null,
            }
            const res = await documentIssuanceVM.onSave(entity, isAdd);
            if (res && res.success) {
                documentIssuanceVM.onCloseClick();
                // messageBarVM.showError(res["mandatoryCheckFail"]?.toString());
                return;
            } else {
                messageBarVM.showError(res.data);
                return;
            }

            //documentIssuanceVM.searchDocIssuance();
        } catch (error) {

        } finally {
            setIsLoading(false)
        }

    }, [currentEntity, documentIssuanceVM, isAdd, messageBarVM, dynamicOptions, companyCode, customerCode]);

    return <Sidebarheader style={{ width: '100%' }}>
        {isLoading && <Loader Indicator="Spinner" size="Medium" />}
        <Breadcrumb>
            <HPHBreadcrumb breadcrumbData={[{ title: DocumentIssuanceConstant.CATEGORY },
            { title: DocumentIssuanceConstant.TITLE }]} onCurrentClick={() => { }}></HPHBreadcrumb>
        </Breadcrumb>
        <StyledAction>
            {(!isAdd && (isEditable && isRead)) &&
                <>
                    {/* Edit Button */}
                    {
                        (
                            (isEditable && allowUpdate)
                        )
                        && <IconButton fileName='Icon-pen' size='medium' toolTipText={'Edit'} toolTipArrow={false} onClick={handleEdit} />
                    }
                    {/* Close Button */}
                    <IconButton fileName='Icon-cross' size='medium' toolTipText={'Close'} toolTipArrow={false} onClick={documentIssuanceVM.onCloseClick} />
                </>}
            {(isAdd || (isEditable && !isRead)) &&
                <>
                    {/* Reset Form Button */}
                    <IconButton fileName="Icon-reset" size="medium" toolTipArrow={false} toolTipPlacement="bottom" toolTipText={'Reset'} onClick={handleReset} />
                    {/* Close Button */}
                    <IconButton fileName="Icon-cross" size="medium" disabled={isDisable()} toolTipArrow={false} toolTipPlacement="left" toolTipText={'Close'} onClick={documentIssuanceVM.onCloseClick} />
                    {/* Save Button */}
                    {
                        (
                            (isAdd && allowCreate) ||
                            (isEditable && allowUpdate)
                        )
                        && <IconButton fileName="Icon-tick" size="medium" disabled={isDisable()} toolTipArrow={false} toolTipPlacement="bottom" toolTipText={'Save'} onClick={() => handleSave()} />
                    }
                </>}
        </StyledAction>
    </Sidebarheader>
}

export default memo(DocumentIssuanceEditPanelTitleBar);